// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown {
  position: relative;
  display: inline-block;
  width: 100%;
}
.dropdown__trigger {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  padding: 0 16px;
  border: var(--m-default-border);
  border-radius: var(--m-border-radius);
  background-color: var(--m-sidebar-background-color);
  color: var(--m-text);
  font-size: 14px;
  font-weight: 400;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
  width: 100%;
  border: none;
}
.dropdown__trigger:hover {
  border-color: #ccc;
  background-color: #F8F8F9;
}
.dropdown__trigger--active {
  border-color: var(--m-primary);
  box-shadow: 0 0 0 2px rgba(var(--m-primary-rgb), 0.2);
}
.dropdown__content {
  z-index: 9999;
  overflow: visible;
}
.dropdown__content--top .dropdown__content-inner {
  margin-top: 0;
  margin-bottom: 0;
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.1), 0 -2px 4px rgba(0, 0, 0, 0.06);
}
.dropdown__content-inner {
  background-color: var(--m-sidebar-background-color, white);
  border: 1px solid var(--m-border, #e2e8f0);
  border-radius: 8px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06);
  overflow: visible;
  min-width: 150px;
  margin-top: 0;
  white-space: nowrap;
}
.dropdown__items-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.dropdown__arrow {
  color: #757575;
  font-size: 22px;
  margin-left: auto;
  transition: transform 0.2s ease;
}
.dropdown__arrow--open {
  transform: rotate(-180deg);
}

.dropdown-portal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 0;
  overflow: visible;
  z-index: 9999;
  pointer-events: none;
}
.dropdown-portal .dropdown__content {
  pointer-events: auto;
}

.dropdown-item {
  padding: 10px 16px;
  cursor: pointer;
  transition: background-color 0.15s ease;
  white-space: nowrap;
  color: var(--m-text, #212529);
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  width: 100%;
  box-sizing: border-box;
}
.dropdown-item:hover {
  background-color: var(--m-dropdown-hover, #f8f9fa);
}
.dropdown-item:hover::before {
  content: "";
  width: 3px;
  height: 100%;
  position: absolute;
  left: 0;
  background-color: var(--m-primary);
  opacity: 0.5;
}
.dropdown-item.active {
  background-color: var(--m-subtle-card-background-color, #e9ecef);
  color: var(--m-primary, #0d6efd);
  font-weight: 500;
  position: relative;
}
.dropdown-item.active::before {
  content: "";
  width: 3px;
  height: 100%;
  position: absolute;
  left: 0;
  background-color: var(--m-primary);
}

[m-data-theme=dark] .dropdown__trigger:hover {
  background-color: rgba(255, 255, 255, 0.03);
}
[m-data-theme=dark] .dropdown__content-inner {
  background-color: var(--m-card-background-color);
  border-color: var(--m-border);
}
[m-data-theme=dark] .dropdown-item {
  color: var(--m-text);
}
[m-data-theme=dark] .dropdown-item:hover {
  background-color: var(--m-dropdown-hover);
}
[m-data-theme=dark] .dropdown-item.active {
  background-color: var(--m-subtle-card-background-color);
  color: var(--m-primary);
}`, "",{"version":3,"sources":["webpack://./src/components/BaseUI/Dropdown/style.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;AACF;AAAE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,qCAAA;EACA,mDAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,yCAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;AAEJ;AADI;EACE,kBAAA;EACA,yBAAA;AAGN;AAAI;EACE,8BAAA;EACA,qDAAA;AAEN;AAEE;EACE,aAAA;EACA,iBAAA;AAAJ;AAEM;EACE,aAAA;EACA,gBAAA;EACA,0EAAA;AAAR;AAII;EACE,0DAAA;EACA,0CAAA;EACA,kBAAA;EACA,wEAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAFN;AAME;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAJJ;AAOE;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;AALJ;AAOI;EACE,0BAAA;AALN;;AAUA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,SAAA;EACA,iBAAA;EACA,aAAA;EACA,oBAAA;AAPF;AASE;EACE,oBAAA;AAPJ;;AAWA;EACE,kBAAA;EACA,eAAA;EACA,uCAAA;EACA,mBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;AARF;AAUE;EACE,kDAAA;AARJ;AAUI;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,kCAAA;EACA,YAAA;AARN;AAYE;EACE,gEAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;AAVJ;AAYI;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,kCAAA;AAVN;;AAkBM;EACE,2CAAA;AAfR;AAmBI;EACE,gDAAA;EACA,6BAAA;AAjBN;AAqBE;EACE,oBAAA;AAnBJ;AAqBI;EACE,yCAAA;AAnBN;AAsBI;EACE,uDAAA;EACA,uBAAA;AApBN","sourcesContent":[".dropdown {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  &__trigger {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    min-height: 40px;\n    padding: 0 16px;\n    border: var(--m-default-border);\n    border-radius: var(--m-border-radius);\n    background-color: var(--m-sidebar-background-color);\n    color: var(--m-text);\n    font-size: 14px;\n    font-weight: 400;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    transition: all 0.2s ease;\n    width: 100%;\n    border: none;\n    &:hover {\n      border-color: #ccc;\n      background-color: #F8F8F9;\n    }\n\n    &--active {\n      border-color: var(--m-primary);\n      box-shadow: 0 0 0 2px rgba(var(--m-primary-rgb), 0.2);\n    }\n  }\n\n  &__content {\n    z-index: 9999;\n    overflow: visible;\n    &--top {\n      .dropdown__content-inner {\n        margin-top: 0;\n        margin-bottom: 0;\n        box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.1), 0 -2px 4px rgba(0, 0, 0, 0.06);\n      }\n    }\n\n    &-inner {\n      background-color: var(--m-sidebar-background-color, white);\n      border: 1px solid var(--m-border, #e2e8f0);\n      border-radius: 8px;\n      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06);\n      overflow: visible;\n      min-width: 150px;\n      margin-top: 0;\n      white-space: nowrap;\n    }\n  }\n\n  &__items-container {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  }\n\n  &__arrow {\n    color: #757575;\n    font-size: 22px;\n    margin-left: auto;\n    transition: transform 0.2s ease;\n\n    &--open {\n      transform: rotate(-180deg);\n    }\n  }\n}\n\n.dropdown-portal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 0;\n  overflow: visible;\n  z-index: 9999;\n  pointer-events: none;\n  \n  .dropdown__content {\n    pointer-events: auto;\n  }\n}\n\n.dropdown-item {\n  padding: 10px 16px;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n  white-space: nowrap;\n  color: var(--m-text, #212529);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  position: relative;\n  width: 100%;\n  box-sizing: border-box;\n\n  &:hover {\n    background-color: var(--m-dropdown-hover, #f8f9fa);\n    \n    &::before {\n      content: '';\n      width: 3px;\n      height: 100%;\n      position: absolute;\n      left: 0;\n      background-color: var(--m-primary);\n      opacity: 0.5;\n    }\n  }\n\n  &.active {\n    background-color: var(--m-subtle-card-background-color, #e9ecef);\n    color: var(--m-primary, #0d6efd);\n    font-weight: 500;\n    position: relative;\n\n    &::before {\n      content: '';\n      width: 3px;\n      height: 100%;\n      position: absolute;\n      left: 0;\n      background-color: var(--m-primary);\n    }\n  }\n}\n\n[m-data-theme=\"dark\"] {\n  .dropdown {\n    &__trigger {\n      &:hover {\n        background-color: rgba(255, 255, 255, 0.03);\n      }\n    }\n\n    &__content-inner {\n      background-color: var(--m-card-background-color);\n      border-color: var(--m-border);\n    }\n  }\n\n  .dropdown-item {\n    color: var(--m-text);\n\n    &:hover {\n      background-color: var(--m-dropdown-hover);\n    }\n\n    &.active {\n      background-color: var(--m-subtle-card-background-color);\n      color: var(--m-primary);\n    }\n  }\n} \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
